import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { matchPath } from 'react-router';
import { ROUTES } from '@/shared/config/routes';

/** The agent builder wants its canvas wide; every other settings page reads fine beside the rail. */
export type SettingsRailArea = 'builder' | 'settings';

interface SettingsRailState {
  /** Only what someone chose; an area they never toggled falls back to its default. */
  collapsed: Partial<Record<SettingsRailArea, boolean>>;
  setCollapsed: (area: SettingsRailArea, collapsed: boolean) => void;
}

const DEFAULT_COLLAPSED: Record<SettingsRailArea, boolean> = { builder: true, settings: false };

export const useSettingsRailStore = create<SettingsRailState>()(
  persist(
    (set) => ({
      collapsed: {},
      setCollapsed: (area, collapsed) =>
        set((state) => ({ collapsed: { ...state.collapsed, [area]: collapsed } })),
    }),
    {
      name: 'organization-settings-rail',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ collapsed: state.collapsed }),
    },
  ),
);

export function settingsRailArea(pathname: string): SettingsRailArea {
  const builder =
    matchPath(ROUTES.ADMIN_CREATE_AGENT, pathname) ??
    matchPath(ROUTES.ADMIN_EDIT_AGENT(':agentId'), pathname);
  return builder ? 'builder' : 'settings';
}

export function useSettingsRailCollapsed(area: SettingsRailArea): boolean {
  return useSettingsRailStore((state) => state.collapsed[area] ?? DEFAULT_COLLAPSED[area]);
}
